(ns ycweb.app.website.dlp.widgets.calltoaction
  (:require
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]))

(rum/defc call-to-action < rum/reactive [component]
  (let [{:call-to-action/keys
         [title copy cta-unset-styles button-text
          button-url button-style button-size button-icon
          show-content? spacer? spacer-size use-date-range?]}
        (:properties component)]
    (when
      (and
        show-content?
        button-text)
      [:<>
       [:div.yc-section 
        [:div.u-block-center.u-max-width-640
         {:class (when-not cta-unset-styles "cta-block")}
         (when title
           (headings/heading title
             {:type :h3
              :size :tiny
              :center true
              :dangerouslySetInnerHTML? true}))
         (when copy
           [:p.yc-paragraph.u-text-center
            {:dangerouslySetInnerHTML
             {:__html copy}}])
         [:div.u-block-center.u-max-width-320.u-text-center
          (buttons/button-web button-text
            {:href button-url
             :style (if (= button-style "light") :secondary :primary)
             :size (if (= button-size "regular") :default :large)
             :full true
             :icon (when (= button-icon "cart") :cart)})]]]
       (when (and spacer? use-date-range?)
         [:div
          {:class (u/bem :dlp-spacer [(if (= spacer-size "medium") :medium :standard)])}])])))
